module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "sendDownstream",
    attrs: {
      "title": _vm.modalTitle,
      "width": 2500,
      "closeButton": ""
    },
    on: {
      "closed": _vm.destroySetup,
      "exited": _vm.destroySetup
    }
  }, [_c('v-tabs', {
    class: {
      'activation-modal__hide-tabs': !this.activatingAudience
    },
    attrs: {
      "color": "primary",
      "slider-color": "primary",
      "centered": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.name
    }, [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('div', {
    staticClass: "activation-modal__name-container__videoamp"
  }, [_c('div', {
    staticClass: "activation-modal__name-section__videoamp"
  }, [_c('v-text-field', {
    attrs: {
      "name": "audienceName",
      "label": "Audience Name",
      "id": "activationModalAudienceName",
      "readonly": "",
      "hide-details": "true",
      "dense": "",
      "filled": ""
    },
    model: {
      value: (_vm.value.display_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "display_name", $$v)
      },
      expression: "value.display_name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__bottom-container"
  }, [_c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('campaign-quarter-select', {
    attrs: {
      "initialValue": _vm.videoampMetadata.campaign_quarter
    },
    on: {
      "updatedCampaignQuarter": function (val) { return (_vm.videoampMetadata.campaign_quarter = val); }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "auto",
      "label": "Advertiser"
    },
    model: {
      value: (_vm.videoampMetadata.advertiser),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "advertiser", $$v)
      },
      expression: "videoampMetadata.advertiser"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "auto",
      "label": "Videoamp ID"
    },
    model: {
      value: (_vm.videoampMetadata.videoamp_id),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "videoamp_id", $$v)
      },
      expression: "videoampMetadata.videoamp_id"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": "",
      "hide-details": "auto",
      "label": "Currency"
    },
    model: {
      value: (_vm.videoampMetadata.currency),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "currency", $$v)
      },
      expression: "videoampMetadata.currency"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "auto",
      "label": "Deal #"
    },
    model: {
      value: (_vm.videoampMetadata.deal_number),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "deal_number", $$v)
      },
      expression: "videoampMetadata.deal_number"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "5"
    }
  }, [_c('demo-id', {
    attrs: {
      "initialValue": _vm.videoampMetadata.demo_id
    },
    on: {
      "updatedDemoId": function (val) { return (_vm.videoampMetadata.demo_id = val); }
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('v-tab-item', [_c('div', {
    staticClass: "activation-modal__name-container"
  }, [_c('div', {
    staticClass: "activation-modal__name-section"
  }, [_c('v-text-field', {
    attrs: {
      "name": "audienceName",
      "label": "Audience Name",
      "id": "activationModalAudienceName",
      "readonly": "",
      "hide-details": "true",
      "dense": "",
      "filled": ""
    },
    model: {
      value: (_vm.value.display_name),
      callback: function($$v) {
        _vm.$set(_vm.value, "display_name", $$v)
      },
      expression: "value.display_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__options-area__advertiser pad"
  }, [_c('div', {
    staticClass: "activation-modal__select-area"
  }, [_c('advertiser-select', {
    attrs: {
      "initialValue": _vm.value.advertiser,
      "showAdvertiserId": true,
      "disabled": _vm.disableAdvertiser,
      "filled": true
    },
    on: {
      "update": function (val) { return (_vm.value.advertiser = val); }
    }
  })], 1)]), _vm._v(" "), (_vm.showViewingStream) ? _c('div', {
    staticClass: "activation-modal__options-area__streaming pad"
  }, [_c('div', {
    staticClass: "activation-modal__select-area"
  }, [_c('streaming-select', {
    attrs: {
      "initialValue": _vm.value.viewing_stream,
      "viewingOption": _vm.viewingOption,
      "disabled": _vm.disableViewingStream
    },
    on: {
      "input": function (val) { return (_vm.value.viewing_stream = val); }
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__bottom-container"
  }, [_c('div', {
    staticClass: "activation-modal__endpoints-area"
  }, _vm._l((_vm.destinations), function(destination) {
    return _c('div', {
      key: destination.id,
      staticClass: "activation-modal__destinations"
    }, [_c('MVPD', {
      attrs: {
        "destination": destination,
        "selected": _vm.value.destinations.includes(destination.id),
        "canUpdate": _vm.canUpdateUE(),
        "UE": 0,
        "MRM_ID": _vm.mrmID()
      },
      on: {
        "selectedDestination": function($event) {
          return _vm.selectDestination(destination)
        },
        "UEChanged": function (ue) { return _vm.updateCanoeUE(ue); },
        "MRMIDChanged": function (mrmId) { return _vm.updateMrmID(mrmId); }
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.foresiteDestinationSelected) ? _c('div', {
    staticClass: "activation-modal__campaign-area"
  }, [(_vm.isDigitalDestination) ? _c('div', {
    staticClass: "xandr-create-target__date-area"
  }, [_c('flight-dates', {
    attrs: {
      "value": {
        flightStartDate: _vm.value.am_data.flightStartDate,
        flightEndDate: _vm.value.am_data.flightEndDate,
      }
    },
    on: {
      "input": function (val) { return Object.assign(_vm.value.am_data, val); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showFrequency) ? _c('v-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('frequency-d-d-l', {
    attrs: {
      "initialValue": _vm.frequency,
      "optionSet": _vm.frequencyOptionSet,
      "disabled": _vm.disableFrequency
    },
    on: {
      "input": function (val) { return (_vm.value.xandr_data.frequency = val); }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.foresiteDestinationSelected) ? _c('div', {
    staticClass: "activation-modal__broadcast-quarter-area"
  }, [_c('broadcast-quarter-select', {
    on: {
      "input": function (val) { return (_vm.broadcastQuarter = val); }
    }
  }), _vm._v(" "), _c('demo-qualifier', {
    on: {
      "demoQualifier": function (val) { return (_vm.demoQualifier = val); }
    }
  })], 1) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "activation-modal__button-area",
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [(_vm.showAdvertiserRequiredMessage) ? _c('div', {
    staticClass: "activation-modal__advertiser-required"
  }, [_vm._v("\n      Advertiser is required in order to send downstream\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.activatingAudience && !_vm.disableSendDownstream) ? _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": _vm.disableSendDownstream,
      "label": "Send Downstream",
      "color": "primary",
      "id": "sendDownstreamModalBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitDownstream.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activatingAudience) ? _c('action-button', {
    attrs: {
      "dark": "",
      "disabled": _vm.disableActivate,
      "label": "Activate",
      "color": "primary",
      "id": "activateAudienceModalBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.activateAudience.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d813338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/sendDownstream/SendDownstream.vue
// module id = 1849
// module chunks = 0